<template>
  <el-container>
    <el-header>
      <HomeHeader />
    </el-header>
    <!-- <el-main class="main-container"> -->
    <router-view></router-view>
    <!-- </el-main> -->
    <Footer v-show="$route.path=='/'" />
  </el-container>
</template>

<script>
import HomeHeader from "./components/commonHeader";
import Footer from "./components/footer.vue";
export default {
  name: "HeaderMainLayout",
  components: {
    HomeHeader,
    Footer
  }
};
</script>
<style lang="scss" scoped>
.el-container.is-vertical {
  min-height: 100vh;
}
.el-main {
  padding: 0 !important;
}
.el-header {
  padding: 0 !important;
  height: auto !important ;
}
</style>
